import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Cpu, Globe, Zap, ChartBar } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ItConsulting() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="itconsulting" className="dark bg-background min-h-[700px] flex items-center justify-center py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl">
          <div className="absolute top-[-10%] left-[10%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px] opacity-60 mix-blend-screen" />
          <div className="absolute bottom-[-10%] right-[10%] w-[600px] h-[600px] bg-blue-900/20 rounded-full blur-[120px] opacity-40 mix-blend-screen" />
        </div>
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-5xl mx-auto">
          {}
          <div className="bg-card/5 backdrop-blur-2xl border border-white/10 rounded-2xl p-8 md:p-20 text-center shadow-2xl relative overflow-hidden ring-1 ring-white/5">
            
            {}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/50 to-transparent opacity-50" />
            
            <div className="relative z-10 flex flex-col items-center">
              {}
              <div className="inline-flex items-center justify-center p-4 mb-8 rounded-full bg-primary/10 border border-primary/20 shadow-[0_0_15px_rgba(6,182,212,0.15)]">
                <Cpu className="w-8 h-8 text-primary animate-pulse" />
              </div>

              {}
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 font-sans tracking-tight drop-shadow-[0_0_25px_rgba(6,182,212,0.2)]">
                IT Consulting
              </h2>

              {}
              <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-3xl mx-auto leading-relaxed font-light">
                Inara Technologies delivers comprehensive AI consulting and cloud services to optimize infrastructure, implement intelligent automation, and drive sustainable growth for your enterprise.
              </p>

              {}
              <div className="flex flex-col sm:flex-row gap-5 justify-center items-center w-full mb-16">
                <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-lg px-10 h-14 shadow-[0_0_20px_rgba(6,182,212,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(6,182,212,0.6)]">
                  <Link to="/ConnectPage">
                    Start Transformation
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
                
                <Button asChild variant="outline" size="lg" className="rounded-lg border-white/10 bg-white/5 text-white hover:bg-white/10 hover:text-primary hover:border-primary/30 font-medium text-lg px-10 h-14 backdrop-blur-sm transition-all">
                  <Link to="/SolutionsPage">
                    Explore Solutions
                  </Link>
                </Button>
              </div>

              {}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full border-t border-white/5 pt-12">
                {[{
                icon: Zap,
                title: "Intelligent Automation",
                desc: "Streamline operations with AI-driven workflows designed for efficiency."
              }, {
                icon: Globe,
                title: "Cloud Migration",
                desc: "Seamlessly migrate to scalable cloud platforms for modern agility."
              }, {
                icon: ChartBar,
                title: "Strategic Optimization",
                desc: "Reduce costs and boost innovation with tailored digital strategies."
              }].map((feature, i) => <div key={i} data-index={i} className="group p-6 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-primary/20 transition-all duration-300 text-left">
                    <div className="mb-4 p-3 rounded-lg bg-primary/10 w-fit group-hover:bg-primary/20 transition-colors">
                      <feature.icon className="w-6 h-6 text-primary" />
                    </div>
                    <h3 className="text-white font-semibold text-lg mb-2 group-hover:text-primary transition-colors">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}